<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-30 23:18:09
 * @LastEditors: Francis
 * @LastEditTime: 2022-08-02 13:56:53
-->
<template>
  <div
    class="auditWork"
    :style="
      component == 'workList1' ? 'padding-top: 230px;' : 'padding-top: 220px;'
    "
  >
    <Header
      menuName="audit"
      :keyWord.sync="keyWord"
      pageName="工单"
      :component.sync="component"
    ></Header>
    <div class="screen" v-if="component == 'workList1'">
      <div
        :class="['scli', { selectscli: this.shipstate == 2 }]"
        @click="queryship(2)"
      >
        江船
      </div>
      <div
        :class="['scli', { selectscli: this.shipstate == 3 }]"
        @click="queryship(3)"
      >
        小船
      </div>
    </div>
    <Footer :page="0" :mineActive="1"></Footer>
    <div class="workList">
      <van-pull-refresh
        v-model="refreshing"
        success-text="刷新成功"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <listItem
            v-for="(item, index) in tableList"
            :key="index"
            :info="item"
            :type.sync="component"
            @action="action"
          ></listItem>
        </van-list>
      </van-pull-refresh>
      <!-- <listItem v-for="(item, index) in tableList" :key="index" :info="item" :type.sync="component" @action="action"></listItem> -->
    </div>
    <van-overlay :show="show" z-index="999999999999">
      <div class="wrapper">
        <div class="block">
          <img
            src="../../../assets/audit/x.png"
            class="icon"
            @click="onClickIcon"
          />
          <p class="title">是否通过审核</p>
          <textarea
            v-model="installPe"
            class="areaed"
            maxlength="50"
            placeholder="请输入驳回理由"
          ></textarea>
          <div class="butt">
            <div class="buttli li1" @click="onClickState(2)">驳回</div>
            <div class="buttli li2" @click="onClickState(5)">不通过</div>
            <div class="buttli li3" @click="onClickState(4)">通过</div>
          </div>
          <!-- <div class="reject" @click="onClickState(2)">驳回</div>
          <div class="reject" @click="onClickState(5)">不通过</div>
          <div class="pass" @click="onClickState(4)">通过</div> -->
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import {
  queryWorkOrderRejectOrPassList,
  queryToVerifyList,
  rejectOrPassWorkOrder,
} from "@/utils/network/interface";
import listItem from "./components/item";

export default {
  name: "auditWork",
  components: {
    Footer,
    Header,
    listItem,
  },
  props: {},
  data() {
    return {
      installPe: "",
      show: false,
      keyWord: "",
      component: "workList1",
      tableList: [],
      refreshing: false,
      loading: false,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      finished: false,
      item: null,
      shipstate: null,
    };
  },
  computed: {},
  watch: {
    keyWord(newVal, oldVal) {
      this.pageInfo.pageNum = 1;
      this.tableList = [];
      this.onLoad();
    },
    component(newVal, oldVal) {
      this.keyWord = "";
      this.tableList = [];
      this.pageInfo.pageNum = 1;
      this.shipstate = null;
      this.getData();
      // this.pageInfo.pageNum++
      console.log(this.finished, "状态");
    },
  },
  created() {},
  mounted() {
    // this.onLoad()
  },
  methods: {
    // onLoad () {
    //   const { pageSize, pageNum } = this.pageInfo
    //   let obj = { pageSize, pageNum }
    //   // let requestObj = {
    //   //   'workList1': queryToVerifyList,
    //   //   'workList2': queryWorkOrderRejectOrPassList,
    //   //   'workList3': queryWorkOrderRejectOrPassList,
    //   // }
    //   let paramesObj = {
    //     'workList1': { state: '3',hipVoyage: this.keyWord, ...obj },
    //     'workList2': { state: '2', shipVoyage: this.keyWord, ...obj },
    //     'workList3': { state: '4', shipVoyage: this.keyWord, ...obj }
    //   }
    //   queryToVerifyList(paramesObj[this.component]).then(res => {
    //     if (res.code === 200) {
    //       if(!res.rows) return this.finished = true,this.loading = false,this.page.pageNum = 1,this.tableList = []
    //       this.tableList = this.tableList.concat(res.rows)
    //       this.pageInfo.pageNum++
    //       this.pageInfo.total = res.total
    //       this.loading = false
    //       if (this.tableList.length >= res.total) {
    //         this.finished = true
    //       }
    //     } else {
    //       this.finished = true
    //     }
    //   }).catch(err => {
    //   })
    // },
    // getData () {
    //   let obj = { pageSize: 10, pageNum: 1, }
    //   let requestObj = {
    //     'workList1': queryToVerifyList,
    //     'workList2': queryWorkOrderRejectOrPassList,
    //     'workList3': queryWorkOrderRejectOrPassList,
    //   }
    //   // const { pageSize, pageNum } = this.pageInfo
    //   // let obj = { pageSize, pageNum }
    //   let paramesObj = {
    //     'workList1': { state: '3',hipVoyage: this.keyWord, ...obj },
    //     'workList2': { state: '2', shipVoyage: this.keyWord, ...obj },
    //     'workList3': { state: '4', shipVoyage: this.keyWord, ...obj }
    //   }
    //   queryToVerifyList(paramesObj[this.component]).then(res => {
    //     // this.tableList = res.data
    //     this.refreshing = false
    //     this.loading = false
    //     if (res.code == 200) {
    //       if(!res.rows) {
    //         this.tableList = []
    //         this.finished = true
    //         this.loading = false
    //         this.pageInfo.pageNum = 1

    //       } else{
    //         this.pageInfo.pageNum++;
    //         this.tableList = res.rows
    //         this.pageInfo.total = res.total
    //       }
    //     } else {
    //       this.tableList = []
    //     }
    //   }).catch(err => {
    //   })
    // },
    onLoad() {
      setTimeout(() => {
        console.log("daodile");

        const { pageSize, pageNum } = this.pageInfo;
        let obj = { pageSize, pageNum };
        let typeList = { workList1: 3, workList2: 2, workList3: 4 };
        let params = {
          bizName: this.keyWord,
          shipType: this.shipstate,
          state: typeList[this.component],
          ...obj,
        };
        queryToVerifyList(params)
          .then((res) => {
            if (res.code === 200) {
              if (!res.rows)
                return (
                  (this.finished = true),
                  (this.loading = false),
                  (this.page.pageNum = 1),
                  (this.tableList = [])
                );
              this.tableList = this.tableList.concat(res.rows);
              this.pageInfo.pageNum++;
              this.pageInfo.total = res.total;
              this.loading = false;
              if (this.tableList.length >= res.total) {
                this.finished = true;
              }
            } else {
              this.finished = true;
            }
          })
          .catch((err) => {});
      }, 1000);
    },
    getData() {
      let obj = { pageSize: 10, pageNum: 1 };
      // const { pageSize, pageNum } = this.pageInfo;
      // let obj = { pageSize, pageNum };
      // let requestObj = {
      //   workList1: workOrderAllOrder,
      //   workList2: queryTakeOrCompleteWorkOrder,
      //   workList3: queryTakeOrCompleteWorkOrder,
      // };
      // let paramesObj = {
      //   workList1: { shipNameVoyage: this.keyWord, ...obj },
      //   workList2: { attribute: "1", shipVoyage: this.keyWord, ...obj },
      //   workList3: { attribute: "2", shipVoyage: this.keyWord, ...obj },
      // };
      // wordOrderList(params)
      let typeList = { workList1: 3, workList2: 2, workList3: 4 };
      let params = {
        bizName: this.keyWord,
        shipType: this.shipstate,
        state: typeList[this.component],
        ...obj,
      };
      // requestObj[this.component](paramesObj[this.component])
      queryToVerifyList(params)
        .then((res) => {
          this.refreshing = false;
          this.loading = false;

          if (res.code == 200) {
            if (!res.rows) {
              this.finished = true;
              this.loading = false;
              this.pageInfo.pageNum = 1;
              this.tableList = [];
            } else {
              this.finished = res.total < 11;
              this.tableList = res.rows;
              this.pageInfo.pageNum++;
              this.pageInfo.total = res.total;
            }
          } else {
            this.tableList = [];
          }
        })
        .catch((err) => {});
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.getData();
      this.pageInfo.pageNum++;
    },
    action(item) {
      console.log(item);
      this.item = item;
      this.show = true;
    },
    onClickIcon() {
      this.show = false;
    },
    onClickState(type) {
      if (type == 2) {
        if (this.installPe) {
          this.show = false;
          rejectOrPassWorkOrder({
            state: type,
            id: this.item.id,
            rejectReason: this.installPe,
          })
            .then((res) => {
              if (res.code === 200) {
                this.getData();
              }
            })
            .catch((err) => {});
        } else {
          this.show = false;

          this.$toast("请输入驳回理由");
        }
      } else if (type == 4) {
        this.show = false;
        rejectOrPassWorkOrder({
          state: type,
          id: this.item.id,
          rejectReason: this.installPe,
        })
          .then((res) => {
            if (res.code === 200) {
              this.getData();
            }
          })
          .catch((err) => {});
      } else if (type == 5) {
        this.show = false;
        rejectOrPassWorkOrder({
          state: type,
          id: this.item.id,
          rejectReason: this.installPe,
        })
          .then((res) => {
            if (res.code === 200) {
              this.getData();
            }
          })
          .catch((err) => {});
      }
    },
    queryship(state) {
      if (state == this.shipstate) {
        this.shipstate = null;
      } else {
        this.shipstate = state;
      }
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.auditWork {
  padding-top: 220px;
  padding-bottom: 70px;

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    z-index: 9999999;

    .block {
      width: 269px;
      padding: 10px;
      // height: 269px;
      background: url("../../../assets/audit/hxBg.png") 0 0 no-repeat;
      background-size: 269px 60px;
      background-color: white;
      border-radius: 10px;

      .areaed {
        width: 90%;
        height: 107px;
        margin: 0 5%;
        background: #eeeeee;
        border: 1px solid #44b1f9;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px;
        resize: none;
        margin-top: 10px;
      }

      .icon {
        width: 11px;
        height: 11px;
        float: right;
        margin-right: 16px;
        margin-top: 15px;
      }

      .title {
        font-size: 16px;
        color: #333333;
        margin-top: 10px;
      }

      .butt {
        width: 100%;
        height: 30px;
        // background-color: #ccc;
        display: flex;
        align-items: center;
        margin: 20px 0;
        .buttli {
          width: 70px;
          height: 28px;

          text-align: center;
          line-height: 28px;
          margin: 0 6px;
          border-radius: 5px;
        }
        .li1 {
          border: 1px solid #f7b346;
          color: #f7b346;
        }
        .li2 {
          border: 1px solid #44b1f9;
          color: #44b1f9;
        }
        .li3 {
          border: 1px solid #44b1f9;
          color: #fff;
          background-color: #44b1f9;
        }
      }
      .reject {
        width: 80px;
        height: 28px;
        border: 1px solid #f7b346;
        border-radius: 5px;
        color: #f7b346;
        text-align: center;
        line-height: 28px;
        float: left;
        margin: 20px 0;
        margin-left: 30px;
      }

      .pass {
        width: 87px;
        height: 28px;
        border-radius: 5px;
        color: white;
        text-align: center;
        line-height: 28px;
        background-color: #44b1f9;
        float: left;
        margin: 20px 0;
        margin-left: 20px;
      }
    }
  }
  .screen {
    position: fixed;
    width: 100%;
    height: 40px;
    background-color: #f4f4f4;
    top: 200px;
    left: 0;
    display: flex;
    align-items: center;
    font-size: 14px;

    z-index: 3;
    padding-left: 20px;
    .scli {
      border: 1px solid #ccc;
      color: #666;
      padding: 2px 8px;
      margin-right: 10px;
      border-radius: 4px;
    }
    .selectscli {
      background-color: #44b1f9;
      border: 1px solid #44b1f9;
      color: #fff;
    }
  }
}
</style>

